import { useCopilotAction } from '@copilotkit/react-core';

import { useAPI } from 'hooks/api/useAPI';

export function useListAvailableMetricsTool() {
  const { applicationID, client } = useAPI();

  useCopilotAction({
    name: 'listAvailableMetrics',
    description:
      'List all available analytics metrics that can be queried. Use this tool to discover what metrics are available before running analytics queries with queryAnalytics tool. Returns metric names and their available dimensions for filtering/grouping.',
    parameters: [],
    handler: async () => {
      try {
        const { data } = await client.get(
          `/apps/${applicationID}/user_metrics`,
          {
            params: {
              pagination: 'offset',
              page: 1,
              limit: 150,
            },
          }
        );

        const metrics = data?.data || [];

        if (metrics.length === 0) {
          return {
            message: 'No metrics available. Metrics are created when pipelines emit data.',
            metrics: [],
          };
        }

        return {
          message: `Found ${metrics.length} available metrics`,
          metrics: metrics.map((metric: { name: string; dimensions: { name: string }[] }) => ({
            name: metric.name,
            dimensions: metric.dimensions.map((dim) => dim.name),
          })),
        };
      } catch (error) {
        return {
          message: 'Failed to load available metrics',
          error: error instanceof Error ? error.message : 'Unknown error',
          metrics: [],
        };
      }
    },
  });
}
